module.exports = __webpack_public_path__ + "img/442-99719b.png";